// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__GtFK2","selected":"Chip_selected__3xgM0"};